import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../App';

const Landing = () => {
	const user = useContext(UserContext);

	if (user) {
		const params = new URLSearchParams(window.location.search);
		const code = params.get('ephemeral-code');
		const codeRedirect = params.get('ephemeral-code-redirect');

		if (code && codeRedirect) {
			return <Navigate replace to={`${codeRedirect }?code=${code}`} />;
		}

		return <Navigate replace to='/events' />;
	}

	return null;
};

export default Landing;
